<template>
  <div>
      <b-row>
          <b-col cols="12" lg="4">
              <app-form-select
                label="Sede"
                v-model="filters.venueId"
                :options="venues"
                value-field="id"
                text-field="name"
              ></app-form-select>
          </b-col>
          <b-col cols="12" lg="3">
              <app-date-picker
                label="Desde"
                v-model="filters.from"
              ></app-date-picker>
          </b-col>
          <b-col cols="12" lg="3">
              <app-date-picker
                label="Hasta"
                v-model="filters.to"
              ></app-date-picker>
          </b-col>
          <b-col cols="12" lg="2" class="d-flex justify-content-end align-items-end">
              <b-btn block @click="onFilter" variant="primary" size="sm" class="mr-2"><i class="fa fa-filter"></i></b-btn>
              <b-btn block @click="onClear" variant="secondary" size="sm"><i class="fa fa-times"></i></b-btn>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
    props: {
        clientId: {
            type: Number,
        }
    },
    data: () => ({
        venues: [],
        filters: {
            venueId: '',
            from: '',
            to: '',
        }
    }),
    watch: {
        clientId(id) {
            this.loadVenues()
        }
    },
    methods: {
        onFilter() {
            this.$emit('filter', this.filters)
        },
        onClear() {
            this.$emit('filter', null)
        },
        async loadVenues() {
            const {data} = await repo.get(`clients/${this.clientId}/venues`)
            this.venues = data
        }
    },
    created() {
        if(this.clientId) {
            this.loadVenues()
        }
    }
}
</script>

<style>

</style>
